<div class="modal-title text-left">Disconnect {{ conflictingAppName }} to Connect {{ newAppName }}</div>
<div class="modal-subtitle with-border"></div>
<div class="modal-content">
    <rosie-alert [type]="'error'" [innerHtml]="warningMessage" [customClass]="'align-items-start'"></rosie-alert>
</div>
<div class="modal-action-line with-border">
    <rosie-button (click)="close()" [customClass]="'secondary'" [translationKey]="'COMMON.CANCEL'">
    </rosie-button>
    <rosie-button (click)="confirm()" [customClass]="'btn-primary inline-with-secondary'"
        translationKey="{{ 'APP.CALENDAR_CONFLICT.CONTINUE' | translate:{ newApp: newAppName } }}">
    </rosie-button>
</div>